import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { calcLegacyTheme } from '../../lib/calc-legacy-theme';
import { GallerySettingsCustomizeHeaderComponent } from '../gallery-settings-customize-header/gallery-settings-customize-header.component';
import { GallerySettingsGroupComponent } from '../gallery-settings-group/gallery-settings-group.component';
import { LayoutPreviewComponent } from '../layout-preview/layout-preview.component';
import { ThemeAssetSizeItemComponent } from '../theme-asset-size-item/theme-asset-size-item.component';
import { ThemeAssetSpacingItemComponent } from '../theme-asset-spacing-item/theme-asset-spacing-item.component';
import { ThemeGridLayoutItemComponent } from '../theme-grid-layout-item/theme-grid-layout-item.component';
import { ThemeLayoutBackgroundColorItemComponent } from '../theme-layout-background-color-item/theme-layout-background-color-item.component';
import { ThemeRoundedCornersItemComponent } from '../theme-rounded-corners-item/theme-rounded-corners-item.component';
import { ThemeSectionVerticalSpacingItemComponent } from '../theme-section-vertical-spacing-item/theme-section-vertical-spacing-item.component';
import { ThemeSectionWidthItemComponent } from '../theme-section-width-item/theme-section-width-item.component';
import { ThemeShowFilenamesItemComponent } from '../theme-show-filenames-item/theme-show-filenames-item.component';

@Component({
  selector: 'app-theme-layout-customize',
  imports: [
    GallerySettingsCustomizeHeaderComponent,
    GallerySettingsGroupComponent,
    ThemeGridLayoutItemComponent,
    LayoutPreviewComponent,
    ThemeAssetSizeItemComponent,
    ThemeAssetSpacingItemComponent,
    ThemeShowFilenamesItemComponent,
    ThemeSectionWidthItemComponent,
    ThemeSectionVerticalSpacingItemComponent,
    ThemeRoundedCornersItemComponent,
    ThemeLayoutBackgroundColorItemComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-layout-customize.component.html',
  styleUrl: './theme-layout-customize.component.scss',
})
export class ThemeLayoutCustomizeComponent {
  gallery = input.required<GalleryDto>();
  theme = computed(() => {
    if (!this.gallery()) return;
    return this.gallery().theme || calcLegacyTheme(this.gallery());
  });
  back = output<void>();
}
